import * as React from 'react';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IState as IBirthdayState } from '../../common/store/birtydays/state';
import { IActions as IBirthdayActions } from '../../common/store/birtydays/actions/creators';
import { actionCreator as birthdaysActions } from '../../common/store/birtydays/actions/creators';
import { IApplicationState } from '../../store/ApplicationState';
import { Grid, CircularProgress, StyledComponentProps, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { styles } from './styles';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { BirthdayList } from './components/List/BirthdayList';
import moment from 'moment';
import { Filters } from './components/Filter/Filters';
import { birthday } from '../../model/birthday';

interface IProps extends IBirthdayActions, IBirthdayState, IMediaQueryProps, StyledComponentProps {
}

interface IState {
    yyyymmdd: string;
    birthDay: string;
    birthdayList: birthday[];
}

class CompContainer extends React.Component<IProps, IState>
{
    state = {
        yyyymmdd: moment().format('YYYYMMDD'),
        birthDay: '',
        birthdayList: [],
    };

    componentDidMount() {
        // const { id } = this.props.match.params;
        if (!this.props.birthdays || this.props.birthdays.length === 0) {
            this.props.loadBirthdays(this.state.yyyymmdd);
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.isLoadingBirthdays === false
            && this.state.birthdayList.length === 0
            && this.props.birthdays.length > 0) {
            this.setFiltro('')
        }
        // do something
    }

    setFiltro = (f: string) => {
        console.log("setFiltro", f, this.props.birthdays.length, " items")
        let _birthdayArray: birthday[] = [];
        this.props.birthdays.map(birthday => {
            if (birthday.birthDate) {
                birthday.natoil = moment(birthday.birthDate).format("DD MMM");
            }
            if (f === '') {
                _birthdayArray.push(birthday);
            }
            else if (birthday.natoil.includes(f)) {
                _birthdayArray.push(birthday);
            }
            return true;
        })
        if (_birthdayArray.length > 0){
            this.setState({ birthdayList: _birthdayArray });
        }
    }

    handleSelection = (_id: string) => {
        // this.setState({ contactsCollapsed: this.props.smallScreen ? true : this.state.contactsCollapsed });
        // this.props.loadTrainer(_id);
    }

    handleFilter = (filtro: string) => {
        this.setState({ birthDay: filtro });
        this.setFiltro(filtro)
    }

    render() {
        // const { id } = this.props.match.params;
        // const { classes } = this.props;
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        handleChangeBirthDay={this.handleFilter}
                        birthDay={this.state.birthDay}
                        classes={this.props.classes}
                        loading={this.props.isLoadingBirthdays}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Paper title='Elenco Compleanni'
                        collapsed={this.props.smallScreen ? true : false} // true --> this.state.contactsCollapsed 
                        fullHeight={false}
                        contentContainerStyle={this.props.smallScreen ? { minHeight: '300px' } : { heigth: 'calc(100% - 1px)' }}>
                        <Grid container spacing={1}>
                            {this.props.isLoadingBirthdays ?
                                <Grid item xs={12} justify={"center"} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                :
                                <>
                                    <Grid item xs={12} >
                                        <BirthdayList 
                                            classes={this.props.classes}
                                            birthdayList={this.state.birthdayList}
                                            selected={this.props.selectedBirthday?._id}
                                            onBirthdayClick={this.handleSelection}
                                        />
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.birthdays,
    ...ownP
})

const mapDispatchToProps = (dispatch: any) => ({
    ...birthdaysActions(dispatch),
    navigateTo: authActions(dispatch).navigateTo
})

export const Birthdays = connect(mapStateToProps, mapDispatchToProps)(WithMediaQuery(withStyles(styles)(CompContainer)));